import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import MuiListItem from '@material-ui/core/ListItem'
import PrintTwoToneIcon from '@material-ui/icons/PrintTwoTone'
import {
  faCoins,
  faCreditCard,
  faEnvelope,
  faHandHoldingUsd,
  faHome,
  faPhone,
  faUser,
  faUtensils
} from '@fortawesome/fontawesome-free-solid'
import moment from 'moment'
import _ from 'lodash'
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike'
import Paper from '../Paper'
import Button from '../Button'
import ListItem from '../ListItem'
import Spinner from '../Spinner'
import Modal from '../Modal'
import 'react-notifications-component/dist/theme.css'
import * as actions from '../../actions/index'
import { displayDate, suitableTime } from '../../utils/suitableDate'
import {
  CANCEL_CLIENT_UNAVAILABLE,
  CANCELLATION_LABELS,
  DELIVEROO,
  DRIVER_CANCEL_REASSIGNMENT,
  FLEET,
  METHODS,
  ORDER_CANCELED_LABEL,
  ORDER_COMPLETED_LABEL,
  ORDER_DELIVEROO,
  ORDER_FLOW_TYPE,
  ORDER_MISSED_LABEL,
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_CONTACTING_LABEL,
  ORDER_PHASE_DELIVERING_LABEL,
  ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL,
  ORDER_PHASE_PREPARING_LABEL,
  ORDER_PHASE_TAKEAWAY_LABEL,
  ORDER_PHASE_WAITER_LABEL,
  ORDER_REFUND_LABEL,
  ORDER_SHOP_CANCELED_LABEL,
  ORDER_TYPE_COLLECT,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_SEAT,
  ORDER_UBEREATS,
  PAYMENT_TYPE_STRIPE,
  PICKUP_STATUS,
  PICKUP_STATUS_KEY,
  SHOP_CANCEL_AND_REFUND,
  SHOP_CANCEL_PHASE_CONTACTING,
  SUITABLE_ORDER_TYPES,
  SUITABLE_PAYMENT_TYPES,
  UNIT,
  DRIVER,
  DEFAULT_SLOT_INTERVAL,
  ORDER_PHASE_PREPARING,
  ORDER_PHASE_DELIVERING_TIME
} from '../../constants'
import { mainColor } from '../../constants/theme'
import { getAddressFormatted } from '../../utils/mapUtils'
import { displayPriceFormat, isObjectNotEmpty } from '../../utils/tools'
import { getCanalName, isExternalApp, setOpacity } from '../../utils/orderUtils'
import { styles } from './OrderModal.styles'

import {
  addTimeToPreparationTime,
  canRefundOrder,
  changePreparationTime,
  findOptionParent,
  formatCategoryName,
  getCancellationReason,
  getDeliveryLogo,
  getSortedDrivers,
  getTrackingUrl,
  handleAcceptDelivery,
  handleCancelOrder,
  handleCustomerTakesOrder,
  handleLunchDelivery,
  handleNewOrder,
  handleOrderReady,
  handleRefundOrder,
  isAnyProviderEnabled,
  isDelivery,
  printTicket,
  pushOrdersToDrivers,
  returnNumber, shouldDisplayScheduledMessage, shouldDisplaySearchingDriverSection, getPaperClassName, shouldDisplayAcceptDelivery,
  getSplashOrderCondition
} from './OrderModal.service'
import fleet from '../../assets/pictures/fleet.png';
import stuartLogo from '../../assets/pictures/stuartLogo.png';
import delivero from '../../assets/pictures/delivero.png';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import MapOrders from '../MapOrders';
import { getSearchingDriverStatus } from '../../components/OrderItem/OrderItem.services';
import uberDirectLogo from '../../assets/pictures/uberDirectLogo.png';
import { ScheduledOrderMessage } from './components/OrderDetailMessage'
import { renderPromotionBloc } from './components/OrderPromotion';
import OrderDetailLine from './components/OrderDetailLine'
import { MOMENT_UNIT } from 'src/constants/date'
const Item = withStyles({
  root: {
    padding: '7px',
    backgroundColor: mainColor.colorWhite,
    '&:hover': {
      backgroundColor: `rgba(100, 100, 100, 0.3)`
    }
  }
})(MuiListItem);

const INITIAL_STATE = {
  isLoadingReception: false,
  valuePreparationTime: 15,
  isOpenDriver: false,
  isLoadingSendingOrder: false
};
class OrderModal extends Component {
  state = INITIAL_STATE;

  componentDidMount() {
    const { order, generalDashboard } = this.props;
    const { isSchedule, canal } = order;
    if (isSchedule || (isExternalApp(canal) && canal !== ORDER_UBEREATS)) {
      this.setState({ valuePreparationTime: 0 });
    }
    else {
      this.setState({ valuePreparationTime: generalDashboard?.manualPreparationTime || INITIAL_STATE.valuePreparationTime });
    }

  }
  componentWillReceiveProps(nextProps) {
    const { order, generalDashboard } = nextProps;
    const { isSchedule, canal } = order;
    const { isOpen } = this.props;
    if (isOpen !== nextProps.isOpen) {
      if (isSchedule || (isExternalApp(canal) && canal !== ORDER_UBEREATS)) {
        this.setState({ valuePreparationTime: 0 });
      } else {
        this.setState({ valuePreparationTime: generalDashboard?.manualPreparationTime || INITIAL_STATE.valuePreparationTime });
      }
    }
    if (order?.delivery?.searchDriver) {
      this.setState({ isLoading: false });
    }
  }

  renderHistoryButton = (currentOrder) => {
    const { showModal } = this.props;
    return (
      <Button
        color='secondary'
        className="btn-xs-block"
        style={{ marginRight: -10 }}
        onClick={() => {
          const modalData = {
            btnColor: 'secondary',
            color: 'secondary',
            title: `Historique de recherche de livreurs`,
            header: true,
            children: this.renderDriversHistory(currentOrder?.driversHistory),
            center: true,
            btnTxt: 'Retour',
            width: '590px',
            height: '200px'
          };
          showModal(modalData);
        }}
      >
        Historique de recherche
      </Button>
    );
  };
  displaySearchingDriver = (currentOrder) => {
    const { classes } = this.props;
    const { isLoadingDriver, isLoading } = this.state;

    const renderSearchingTitle = () => (
      <div
        className="d-flex align-items-center justify-content-between"
      >
        <p className={classes.subtitle}>En recherche de livreurs</p>
        {currentOrder?.driversHistory?.some((driver) => driver.name) && <div className="d-flex">{this.renderHistoryButton(currentOrder)}</div>}
      </div>
    );

    const renderSearchDriverButton = () => (
      <>
        <p className={`${classes.subtitle} pb-1`}>Chercher un livreur</p>
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 85 }}>
          <Button
            color="success"
            outlined
            padding="sm"
            minWidth="0px"
            className={`${classes.searchDriver}`}
            onClick={() => pushOrdersToDrivers(this, currentOrder)}
            disabled={currentOrder?.delivery?.searchDriver || this.state.isLoadingSendingOrder}
            style={{ width: '324px' }}
            isLoading={this.state.isLoadingSendingOrder}
          >
            Envoyer aux livreurs
          </Button>
        </div>
      </>
    );

    const renderStatus = (logo, name, content) => (
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <img src={logo} alt={`${name} Logo`} className={classes.animatedLogo} />
          <b className="pl-3">{name}</b>
        </div>
        {content && content}
      </div>
    );

    const renderStatusList = () => {
      const { deliveroo, stuart, uberDirect, driversHistory } = currentOrder || {};
      const hasDriverContact = driversHistory?.some(driver => driver.name);
      const sortedDrivers = getSortedDrivers(driversHistory) || [];
      const driverName = sortedDrivers[0]?.name;


      const getActiveService = () => {
        if (deliveroo?.jobId) return { logo: delivero, name: 'Deliveroo' };
        if (uberDirect?.jobId) return { logo: uberDirectLogo, name: 'Uber Direct' };
        if (stuart?.jobId) return { logo: stuartLogo, name: 'Stuart' };
        if (currentOrder?.delivery?.jobId) {
          return {
            logo: fleet,
            name: 'Dishop Fleet',
            extra: hasDriverContact && (
              <span className="pl-5">
                En contact avec <b>{driverName}</b>
                <div className="dot-animation"></div>
              </span>
            )
          };
        }
        return null;
      };

      const activeService = getActiveService();

      if (!activeService && _.size(sortedDrivers) === 0) {
        return (
          <div className="d-flex flex-column" style={{ gap: UNIT * 1 }}>
            <div
              className="d-flex align-items-center justify-content-between"
            >
              <p className={classes.subtitle}>En recherche de livreurs</p>

            </div>
            <div className="text-muted"> Lancement de la recherche...</div>
          </div>
        );
      }

      return (
        <div className="d-flex flex-column" style={{ gap: UNIT * 1 }}>
          {renderSearchingTitle()}
          {renderStatus(activeService?.logo, activeService?.name, activeService?.extra)}
        </div>
      );
    };

    return (
      <div className={classes.dynMarg}>
        {isLoading || isLoadingDriver ? (
          <div className='d-flex align-self-center align-items-center justify-content-center' style={{ minHeight: 85 }}>
            <Spinner size={20} />
          </div>
        ) : (
          (currentOrder?.statusLabel === ORDER_PHASE_PREPARING_LABEL || getSearchingDriverStatus(currentOrder) === ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL) &&
            !currentOrder?.delivery?.searchDriver ? (
            renderSearchDriverButton()
          ) : (
            renderStatusList()
          )
        )}
      </div>
    );
  };

  displayLookingForDriver = (currentOrder) => {
    const { classes } = this.props;

    if (shouldDisplayAcceptDelivery(currentOrder)) {
      return (
        <div className={classes.dynMarg}>
          <div className="col-12 my-4 d-flex align-items-center justify-content-center">
            <Button
              color="success"
              padding="sm"
              minWidth="0px"
              className="m-0 py-md-3 py-lg-2 py-sm-3 px-3"
              style={{ fontSize: UNIT * 0.9375, borderWidth: '2px' }}
              onClick={() => handleAcceptDelivery(currentOrder, this)}
            >
              Je prends en charge la responsabilité de la livraison
            </Button>
          </div>
          <div className="d-flex mb-4 align-items-center justify-content-center">
            <Button
              outlined
              color="danger"
              padding="sm"
              minWidth="0px"
              className="m-0 py-md-3 py-lg-2 py-sm-3 px-3"
              onClick={() => handleCancelOrder(currentOrder, this, SHOP_CANCEL_PHASE_CONTACTING)}
            >
              <p>Refuser la commande</p>
            </Button>
          </div>
        </div>
      );
    }

    if (!this.state.isLoadingDriver && !this.state.isLoadingReception && shouldDisplayScheduledMessage(currentOrder)) {
      return (
        this.renderScheduledMessage(currentOrder)
      );
    }
    if (!currentOrder?.delivery?.searchDriver || (currentOrder?.delivery?.searchDriver && !shouldDisplayAcceptDelivery(currentOrder)))
      return (
        this.displaySearchingDriver(currentOrder)
      )
    else return <div className='d-flex align-self-center align-items-center justify-content-center' style={{ minHeight: 85 }}>
      <Spinner size={20} />
    </div>;
  };



  renderScheduledMessage = (currentOrder) => {
    if (!currentOrder) return null;

    return (
      <div className="d-flex flex-column align-items-center justify-content-center my-4">
        <p style={{ textAlign: 'center' }}>
          Cette commande est programmée pour{' '}
          <strong>{`${suitableTime(moment(currentOrder.date))}`}</strong>.
          <br />
          Nous commencerons à chercher un livreur{' '}
          <strong>30 minutes</strong> avant la date souhaitée par le client.
        </p>
      </div>
    );
  };

  displayPhaseOne = (currentOrder) => {
    const { classes, autoAccept } = this.props;
    const { valuePreparationTime } = this.state;
    const { isSchedule, canal } = currentOrder;
    const sentence = autoAccept ? 'Ajuster l’heure de sortie de cuisine' : 'Ajuster le temps de préparation';
    return (
      <div className={classes.dynMarg}>
        {getSplashOrderCondition(currentOrder) && autoAccept?.enabled ? (
          <div className={`d-flex justify-content-center align-items-center my-4`}>
            <ScheduledOrderMessage classes={classes} order={currentOrder} />
          </div>
        ) : (
          <>
            {(!isExternalApp(canal) || canal === ORDER_UBEREATS) && (
              <>
                <div className='d-flex align-items-center justify-content-center'>
                  <p className='p-0 text-center' style={{ fontSize: '16px', fontWeight: 'bolder' }}>
                    {sentence}
                  </p>
                </div>

                <div className='d-flex align-items-center justify-content-center p-0'>
                  <div className='row ml-0 mr-0 mt-1 justify-content-center align-items-center'>
                    <Button
                      color='secondary'
                      outlined
                      padding='sm'
                      minWidth='0px'
                      className='mr-0'
                      style={{ fontSize: UNIT * 0.9375 }}
                      onClick={() => changePreparationTime(this, -5)}
                    >
                      - 5
                    </Button>
                    <p className='mx-2 align-self-center m-0 font-weight-bolder'>
                      {valuePreparationTime === 0 && isSchedule
                        ? "à l'heure"
                        : `${valuePreparationTime} min`}
                    </p>
                    <Button
                      color='secondary'
                      outlined
                      padding='sm'
                      minWidth='0px'
                      style={{ fontSize: UNIT * 0.9375 }}
                      onClick={() => changePreparationTime(this, 5)}
                    >
                      + 5
                    </Button>
                  </div>
                </div>
              </>
            )}
            <div className='d-flex my-4'>
              <div className='d-flex mr-3'>
                <Button
                  color='success'
                  padding='lg'
                  style={{ fontSize: UNIT, padding: '10px 20px', fontWeight: 'bolder' }}
                  onClick={() => handleNewOrder(this, currentOrder, valuePreparationTime)}
                >
                  Accepter la commande
                </Button>
              </div>

              <div className='d-flex'>
                <Button
                  outlined
                  color='danger'
                  padding='sm'
                  minWidth='0px'
                  className='mr-0'
                  style={{ padding: '10px 20px' }}
                  onClick={() => handleCancelOrder(currentOrder, this, SHOP_CANCEL_PHASE_CONTACTING)}
                >
                  <p>Refuser la commande</p>
                </Button>
              </div>

            </div>

          </>
        )}
      </div>

    );
  };



  displayPhaseTwo = currentOrder => {
    const { classes, showOrderInPreparation, dashboard = {}, isAllShops, driversAvailability } = this.props;
    const { nbDriversAvailable = 0, nbDriversFreelance = 0 } = driversAvailability;
    const { acceptDeliveryFromDashboard = isAllShops } = dashboard;
    const { orderType, canal, orderFlowType = ORDER_FLOW_TYPE.CLASSIC, shopResponsibleForDelivery } = currentOrder;
    const showRefundButton = canRefundOrder(currentOrder, this);
    const infoMessage = isDelivery(orderType)
      ? 'La commande est prête ?'
      : 'La commande est terminée ?';
    const showDeliveryButton = !showOrderInPreparation;
    const isReverseOrderFlowType = (orderFlowType === ORDER_FLOW_TYPE.REVERSE && currentOrder?.pickupStatus === PICKUP_STATUS_KEY.ORDER_NOT_CURRENTLY_SUPPORTED)
    const showAddTimeButton = (isDelivery(orderType) && (((!showOrderInPreparation || acceptDeliveryFromDashboard) && currentOrder?.pickupStatus === PICKUP_STATUS_KEY.ORDER_NOT_CURRENTLY_SUPPORTED) || shopResponsibleForDelivery))
      || (!isDelivery(orderType) &&
        !isExternalApp(canal))


    return (
      <div className={classes.dynMarg}>
        {getSplashOrderCondition(currentOrder) ? (
          <>
            <ScheduledOrderMessage classes={classes} order={currentOrder} />
          </>
        ) : (
          <>
            {((isDelivery(orderType) && (!showOrderInPreparation || acceptDeliveryFromDashboard)) ||
              !isDelivery(orderType)) &&
              !isExternalApp(canal) && (
                <div className={classes.cookingStyle}>
                  <p className={classes.title}>
                    <b>{infoMessage}</b>
                  </p>
                  {showAddTimeButton &&
                    <Button
                      outlined
                      color='secondary'
                      padding='sm'
                      minWidth='0px'
                      style={{ fontSize: UNIT * 0.93, marginLeft: 5 }}
                      onClick={() => addTimeToPreparationTime(this, currentOrder)}
                    >
                      + 15 minutes de préparation
                    </Button>
                  }
                </div>
              )}

            <div className='my-2 row d-flex align-self-center align-items-center justify-content-center' style={{ display: 'flex' }}>
              {isDelivery(orderType) ?
                (currentOrder?.pickupStatus === PICKUP_STATUS_KEY.ORDER_NOT_CURRENTLY_SUPPORTED) ? (
                  <div className='row' style={{ justifyContent: 'center' }}>

                    {(shouldDisplayAcceptDelivery(currentOrder) || (!isReverseOrderFlowType && acceptDeliveryFromDashboard && !nbDriversAvailable && !nbDriversFreelance)) && (
                      <div
                        className={showDeliveryButton || isReverseOrderFlowType ?
                          (!showRefundButton || isReverseOrderFlowType ? 'col-12 my-2' : 'col-12 p-2') :
                          'col-12 mt-3'
                        }
                        style={{ textAlign: 'center' }}
                      >
                        <Button
                          color='success'
                          padding='sm'
                          minWidth='0px'
                          className={classes.searchDriver}
                          style={{ fontSize: UNIT * 0.9375, borderWidth: '2px' }}
                          onClick={() => handleAcceptDelivery(currentOrder, this)}
                        >
                          Je prends en charge la responsabilité de la livraison
                        </Button>
                      </div>
                    )}
                  </div>

                ) : (
                  shopResponsibleForDelivery && <div
                    className={showDeliveryButton || isReverseOrderFlowType ?
                      (!showRefundButton || isReverseOrderFlowType ? 'col-12' : 'col-12 p-2') :
                      'col-12 mt-3'
                    }
                    style={{ textAlign: 'center' }}
                  >
                    <Button
                      color='success'
                      padding='sm'
                      style={{ fontSize: UNIT * 1.1, padding: '15px 50px', fontWeight: 'bolder', margin: 20 }}
                      onClick={() => handleLunchDelivery(currentOrder, this)}
                    >
                      Je démarre la livraison
                    </Button>
                  </div>) : (
                  <Button
                    color='success'
                    padding='sm'
                    style={{ fontSize: UNIT * 1.1, padding: '15px 50px', fontWeight: 'bolder', margin: 20 }}
                    onClick={() => handleOrderReady(currentOrder, this)}
                  >
                    Commande prête
                  </Button>
                )
              }
            </div >


            {!isExternalApp(canal) && this.renderCancelsButtons(currentOrder)
            }
          </>
        )}
      </div >
    );
  };

  displayPhaseThree = currentOrder => {
    const { classes, dashboard = {}, isAllShops } = this.props;
    const { validateDeliveryFromDashboard = isAllShops } = dashboard;
    const { canal, orderType, statusLabel, delivery = {}, shopResponsibleForDelivery } = currentOrder;
    const { searchDriver } = delivery;
    const { isLoadingDriver, isLoadingReception } = this.state;
    return (
      <div className={`${statusLabel !== ORDER_PHASE_DELIVERING_LABEL && 'mt-md-3'} ${isLoadingDriver && classes.disableStyle}`} >
        <p className={classes.subtitle} style={{ textAlign: 'center' }}>
          {isDelivery(orderType)
            ? isExternalApp(canal)
              ? 'La commande est prête ?'
              : 'La livraison est terminée ?'
            : 'Le client est passé prendre sa commande ?'}
        </p>
        <div
          className={`row ml-0 mr-0  justify-content-center`}>
          {isAnyProviderEnabled(currentOrder) && [PICKUP_STATUS_KEY.DRIVER_ON_THE_WAY_TO_RESTAURANT, PICKUP_STATUS_KEY.DRIVER_NEAR_TO_RESTAURANT].includes(currentOrder?.pickupStatus) && (
            <div className='mb-3 row  d-flex align-self-center align-items-center justify-content-center'>
              <Button
                color="success"
                outlined
                padding="sm"
                minWidth="0px"
                className={classes.searchDriver}
                disabled={searchDriver}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className={classes.message}>
                    {PICKUP_STATUS('')[currentOrder?.pickupStatus]}
                  </p>
                  {currentOrder?.pickupStatus === PICKUP_STATUS_KEY.DRIVER_ON_THE_WAY_TO_RESTAURANT ?
                    <div className='pl-2'>
                      <img
                        src={getDeliveryLogo(currentOrder?.delivery?.nature)}
                        className={classes.logo}
                      />
                    </div> :
                    <Spinner size={20}
                      style={{
                        color: mainColor.secondaryColor,
                        marginLeft: '10px'
                      }}

                    />}
                </div>
              </Button>
            </div>)}
          {(shopResponsibleForDelivery || (validateDeliveryFromDashboard || orderType !== ORDER_TYPE_DELIVERY)) && !isLoadingReception &&
            <div className='row  d-flex align-self-center align-items-center justify-content-center'>
              <Button
                color='success'
                padding='lg'
                minWidth='0px'
                className='py-3 px-6'
                style={{ fontSize: UNIT * 1.2, fontWeight: 'bolder', margin: 20 }}
                onClick={() => handleCustomerTakesOrder(currentOrder, this)}
              >
                Valider la commande
              </Button>
            </div>
          }
        </div>
        {!isExternalApp(canal) && this.renderCancelsButtons(currentOrder)}
      </div>

    );
  };

  displayPhaseFour = currentOrder => {
    const { statusLabel, orderType } = currentOrder;
    const isPastOrder = statusLabel === ORDER_COMPLETED_LABEL;
    const showRefund =
      canRefundOrder(currentOrder, this) &&
      (statusLabel === ORDER_COMPLETED_LABEL || statusLabel === ORDER_CANCELED_LABEL);
    return (
      showRefund && (
        <div
          className={`${orderType === ORDER_TYPE_SEAT ? 'd-inline-block d-sm-flex' : ''}`}
          style={{
            width: 'fit-content'
          }}
        >
          <ListItem title='Vous souhaitez rembourser votre client ?' icon={faHandHoldingUsd} />
          <div className='d-flex align-items-center justify-content-center'>
            {this.renderCancelButton(currentOrder, {
              typeCancel: 'rembourser',
              isCompleted: true,
              onClick: () => {
                handleRefundOrder(currentOrder, isPastOrder, this);
              },
              btnTxt: 'Rembourser',
              color: 'secondary'
            })}
          </div>
        </div>
      )
    );
  };

  displayOrderDetail = ({ title, body, color, isDate, description }) => {
    const { classes } = this.props;
    return (
      <div className='mb-2'>
        <p className={`${isDate && 'justify-content-xs-start'}  ${classes.orderDetail}`}>
          <span style={{ whiteSpace: 'nowrap' }}>{title}</span>
          {body && (
            <>
              <b className={classes.boldText} style={{ color }}>
                {body}
              </b>
              {description && <div className={classes.description}>{description}</div>}
            </>
          )}
        </p>
      </div>
    );
  };

  displayPaymentType = order => {
    const { paymentType, statusLabel } = order;
    const { classes } = this.props;
    const getPaymentText = () => {
      if (!paymentType) return 'Non payé';

      const isPaid = paymentType === PAYMENT_TYPE_STRIPE || statusLabel === ORDER_COMPLETED_LABEL;
      const paymentStatus = isPaid ? 'Payé' : 'À payer';

      return `${paymentStatus} ${SUITABLE_PAYMENT_TYPES[paymentType]?.replace('Paiement', '')?.toLowerCase() || ''}`;
    };
    return (
      <div className='col px-0'>
        <p className={classes.subtitle} style={{ marginBottom: UNIT * 0.3125 }}>
          MODE DE PAIEMENT
        </p>
        <ListItem
          title={getPaymentText()}
          icon={paymentType === 'cash' ? faCoins : faCreditCard}
          isbolder
        />
      </div>
    );
  };

  renderCancelButton = (order, modalData) => {
    const { orderNumber, totalPriceOrder = 0 } = order;
    const { showModal } = this.props;
    const { isLoadingReception, isLoadingDriver } = this.state;
    const {
      color = 'danger',
      title = null,
      onClick,
      btnTxt,
      btnColor = 'danger',
      showCancelBtn = true,
      typeCancel,
      isCompleted
    } = modalData;
    const dataToUse = {
      color,
      title:
        title ||
        `Êtes-vous sûr(e) de vouloir ${typeCancel} la commande "${orderNumber}" d'un montant de ${displayPriceFormat(totalPriceOrder)} ?`,
      showCancelBtn,
      btnColor,
      onClick: () => {
        onClick();
        showModal(null);
      },
      size: 'md',
      btnTxt: 'Valider'
    };
    return (isLoadingReception || (isLoadingDriver && title)) ? (
      <Spinner size={20} />
    ) : (
      <Button
        color={color}
        outlined
        variant='contained'
        padding={!isCompleted ? 'sm' : 'xs'}
        minWidth='0px'
        onClick={() => showModal(dataToUse)}
      >
        {btnTxt} {!isCompleted && !title ? 'la commande' : null}
      </Button>
    );
  };

  renderFollowDriverButton = (currentOrder) => {
    const followLink = getTrackingUrl(currentOrder);
    const { showModal } = this.props;
    if (!followLink && currentOrder.delivery.nature && currentOrder?.delivery?.nature?.toUpperCase() !== FLEET) return null
    return (
      <Button
        color="primary"
        className="btn-xs-block"
        onClick={() => {
          if (!isExternalApp(currentOrder?.canal) && followLink) {
            window.open(followLink, '_blank', 'noopener,noreferrer');
          } else {
            const modalData = {
              color: 'success',
              title: `Suivre le livreur ${currentOrder?.userNameDep || '--'} ${currentOrder?.userLastNameDep || ''}`,
              header: true,
              children: (
                <MapOrders
                  isLoading={this.state.isLoading}
                  orders={[currentOrder]}
                />
              ),
              width: '700px',
              center: true,
              modalBodyClass: 'justify-content-center d-flex pb-0',
              btnTxt: 'Retour',
            };
            showModal(modalData);
          }
        }}
      >
        Suivre le livreur
      </Button>
    );
  };

  displayDriverDetail = (currentOrder, isCompleted, shouldHideOrderPhase) => {
    const { classes, isAllShops } = this.props;
    const isFleetDriver = !isCompleted &&
      currentOrder?.delivery?.nature?.toUpperCase() === FLEET &&
      currentOrder?.pickupStatus !== PICKUP_STATUS_KEY.DRIVER_ON_THE_WAY_TO_CUSTOMER;
    const isDeliveroo = !isCompleted && shouldHideOrderPhase
    const estimatedHour =
      currentOrder?.expectedPickupDate && isDeliveroo ? `- Heure d'arrivée estimée ${suitableTime(moment(currentOrder?.expectedPickupDate))}` : '';

    const driverIsIndependent = currentOrder?.delivery?.freelance;
    const deliveryNature = currentOrder?.delivery?.nature?.toUpperCase();
    const isFleet = deliveryNature === FLEET;

    let driverTitle = `COORDONNÉES LIVREUR ${deliveryNature || ''}`;
    if (isFleet && typeof driverIsIndependent === 'boolean') {
      driverTitle = driverIsIndependent
        ? 'COORDONNÉES LIVREUR INDÉPENDANT'
        : 'COORDONNÉES LIVREUR EMPLOYÉ';
    }

    return (
      <Paper
        className={`
  col-sm-12 col-md-12 col-lg-12
          }
  ${currentOrder?.statusLabel === ORDER_PHASE_DELIVERING_LABEL && !shouldHideOrderPhase
            ? classes.deliveryStyle
            : shouldHideOrderPhase ? !isAllShops ? !isCompleted ? classes.deliveryDriverShopDetailsStyle : classes.deliverySectionStyle
              : classes.deliveryDriverDetailsStyle
              : classes.deliverySectionStyle
          }
`}

      >
        <div className="d-flex justify-content-between align-items-center" style={{ padding: 0 }}>
          <p className={currentOrder?.driversHistory?.some((driver) => driver.name) ?
            classes.driverTitle : classes.subtitle}>
            {driverTitle}
          </p>
          {currentOrder?.driversHistory?.some((driver) => driver.name)
            ? this.renderHistoryButton(currentOrder)
            : <div className="d-flex align-items-center justify-content-between">{!isCompleted && !isAllShops && this.renderFollowDriverButton(currentOrder)}</div>}
        </div>

        <div className="d-flex justify-content-between align-items-start">
          <div>
            <ListItem
              title={`${currentOrder?.userNameDep || '--'} ${currentOrder?.userLastNameDep || ''} ${estimatedHour}`}
              icon={faUser}
              noPadding
            />
            {currentOrder?.numeroDep && <ListItem title={returnNumber(currentOrder?.numeroDep) || '--'} icon={faPhone} noPadding />}
          </div>
        </div>

        {!isCompleted && !isAllShops && currentOrder?.driversHistory?.some((driver) => driver.name) && (
          <div className="d-flex justify-content-center mt-2">
            {this.renderFollowDriverButton(currentOrder)}
            {isFleetDriver && (
              <div className="d-flex align-items-center">
                {this.renderCancelButton(currentOrder, {
                  typeCancel: 'retirer',
                  onClick: () => {
                    handleCancelOrder(currentOrder, this, DRIVER_CANCEL_REASSIGNMENT);
                  },
                  btnTxt: 'Changer le livreur',
                  color: 'danger',
                  title: `Êtes-vous sûr(e) de vouloir retirer la commande à ${currentOrder.userNameDep}?`,
                })}
              </div>
            )}
          </div>
        )}
        {isDeliveroo && this.displayDeliverooMap(currentOrder)}
      </Paper >
    );
  };
  displayDeliverooMap = (currentOrder) => {
    return (
      <>
        <div className='pb-2'>
          {currentOrder?.pickupStatus === PICKUP_STATUS_KEY.DRIVER_ON_THE_WAY_TO_CUSTOMER && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '-7px' }}>
                <div style={{ width: '100%', fontWeight: 500 }}>Code de validation client</div>
                <strong style={{ fontSize: '24px', fontWeight: 'bold' }}>
                  {currentOrder?.validationCode}
                </strong>
              </div>
              <p style={{ color: 'red', marginTop: '-10px' }}>
                Si votre client perd son code de validation vous pouvez lui fournir
              </p>

            </div>
          )}
        </div>
        <MapOrders
          style={{
            borderRadius: UNIT,
            overflow: 'hidden',
            width: '100%',
            height: '100%',
          }}
          isLoading={this.state.isLoading}
          orders={[currentOrder]}
          isPaperDisplay={true}
          isExternalDriver={true}
          zoom={14}
          zoomDef={14}
        />

      </>
    );
  };
  renderCancelsButtons = currentOrder => {
    const { statusLabel, shopResponsibleForDelivery, delivery } = currentOrder;
    const isFleetOrder = delivery?.jobId;
    const showButtons = (isFleetOrder || shopResponsibleForDelivery) ? true : currentOrder.pickupStatus === 0;
    const showRefundButton = showButtons && canRefundOrder(currentOrder, this);
    const showCancelButton = showButtons && (
      statusLabel === ORDER_PHASE_DELIVERING_LABEL ||
      statusLabel === ORDER_PHASE_TAKEAWAY_LABEL ||
      statusLabel === ORDER_PHASE_WAITER_LABEL ||
      statusLabel === ORDER_PHASE_PREPARING_LABEL
    );
    if (!showCancelButton && !showRefundButton) return null;
    return (
      <div className='row d-flex align-self-center align-items-center justify-content-center'>
        {showCancelButton && (
          <div className={`d-flex align-items-center justify-content-center ${showCancelButton ? 'col-lg-5 col-sm-6 p-0' : 'col-12'
            } ${statusLabel === ORDER_PHASE_DELIVERING_LABEL ? 'col-md-5' : 'col-md-12'
            }`}>
            {this.renderCancelButton(currentOrder, {
              typeCancel: 'annuler',
              onClick: () => handleCancelOrder(currentOrder, this, CANCEL_CLIENT_UNAVAILABLE),
              btnTxt: 'Annuler',
              color: 'danger'
            })}
          </div>
        )}

        {showRefundButton && (
          <div className={`d-flex align-items-center justify-content-center col-lg-6 col-sm-12 p-0 ${statusLabel === ORDER_PHASE_DELIVERING_LABEL ? 'col-md-6' : 'col-md-12'
            }`}>
            {this.renderCancelButton(currentOrder, {
              typeCancel: 'rembourser',
              onClick: () => handleCancelOrder(currentOrder, this, SHOP_CANCEL_AND_REFUND),
              btnTxt: 'Rembourser'
            })}
          </div>
        )}
      </div>
    );
  };

  renderDriversHistory = (driversHistory) => {
    const sortedData = getSortedDrivers(driversHistory);
    return (
      <div style={{ height: 300, overflow: 'auto' }}>
        {sortedData.map((item, index) => {
          const formattedDate = moment(item.date).format('DD/MM/YYYY');
          const formattedTime = moment(item.date).format('HH[h]mm [et] ss [secondes]');
          return (
            <div
              key={index}
              style={{ padding: '5px 0px' }}
            >
              <span style={{ fontWeight: 'bold', fontSize: UNIT * 0.75 }}>
                {item.name}
              </span>{' '}
              est contacté
              <span style={{ fontWeight: 'normal' }}>
                {' '}
                par {METHODS[item.method] || item.method}
              </span>{' '}
              le {formattedDate} à{' '}
              <span style={{ fontWeight: 'bold', fontSize: UNIT * 0.75 }}>
                {formattedTime}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  renderPrintTicketIcon = (shopId, status, order, classes) => {
    return (
      checkIntegrationAccess('order', 'hideprintTicket', shopId) || status === ORDER_PHASE_CONTACTING) ? null : (
      <div className='row justify-content-end'>
        <Item
          button
          onClick={() => printTicket(this, order, true)}
          className={classes.iconStyle}
        >
          <PrintTwoToneIcon fontSize='large' />
        </Item>
      </div>
    )
  }


  renderOptions = (e) => {
    const { classes } = this.props;
    if (!e.items) return null;
    return _.map(_.orderBy(e.items, ['categoryPosition']), item => {
      if (!item) return null;

      const { options, categoryKey, categoryName: initialCategoryName } = item;
      const isChild = this.isChildCategory(categoryKey, e.items);
      const categoryName = isChild ? this.getFormattedCategoryName(item, e.items) : initialCategoryName;
      const optionLabels = this.getOptionLabels(options);

      return this.renderItem(categoryName, optionLabels, classes);
    });
  };

  isChildCategory = (categoryKey, items) => {
    return _.some(items, childItem =>
      childItem?.categoryKey !== categoryKey && categoryKey.includes(childItem?.categoryKey)
    );
  };

  getFormattedCategoryName = (item, items) => {
    let { categoryName } = item;

    _.forEach(item.options, option => {
      const optionParent = findOptionParent(option, items);
      if (optionParent) {
        categoryName = formatCategoryName({
          shopCategory: { name: item.categoryName },
          parentItemLabel: optionParent.label,
          parentItemRecursiveKey: optionParent.itemRecursiveKey,
          isMultiple: optionParent.categoryMultiple
        });
      }
    });

    return categoryName;
  };

  getOptionLabels = (options) => {
    return _.map(options, option =>
      `${option.label} (+${displayPriceFormat(option.price)})`
    );
  };

  renderItem = (categoryName, optionLabels, classes) => {
    const itemRenderString = `- ${categoryName}: ${optionLabels.join(', ')}`;

    return (
      <div key={Math.random().toString(36).substring(2, 15)}>
        <p className={classes.textDetails} style={{ display: 'inline-block' }}>
          {itemRenderString}
        </p>
        <br />
      </div>
    );
  };



  render() {
    const {
      classes,
      handleClose,
      order = {},
      isOpen,
      isAllShops, hours
    } = this.props;
    const { isLoadingReception } = this.state;
    const {
      userServicePrice = 0,
      managementFee = 0,
      address = {},
      promotion = {},
      canal,
      firstName,
      lastName = '',
      numero,
      totalPriceOrder,
      orderType,
      email,
      shop = {},
      date,
      datePreparationStarted,
      preparationTime,
      expectedDropoffDate = null,
      status,
      userNameDep,
      shopId,
      externalOrderNumber,
      tableNb = '',
      pickupStatus,
      orderFlowType = ORDER_FLOW_TYPE.CLASSIC,
      shopResponsibleForDelivery
    } = order;
    const datePreparationEnded = moment(datePreparationStarted).add(preparationTime, MOMENT_UNIT.MINUTE).format();
    const statusLabel = getSearchingDriverStatus(order)
    const isCompleted =
      statusLabel === ORDER_CANCELED_LABEL ||
      statusLabel === ORDER_COMPLETED_LABEL ||
      statusLabel === ORDER_MISSED_LABEL ||
      statusLabel === ORDER_REFUND_LABEL ||
      statusLabel === ORDER_SHOP_CANCELED_LABEL;
    const momentDate = moment(datePreparationEnded || date);
    const time = suitableTime(momentDate);
    const { type, promoCode, reconversionType } = promotion;
    const isDisplayDriverDetails = (() => {

      const isDelivering = statusLabel === ORDER_PHASE_DELIVERING_LABEL;
      const isPreparingAndPickedUp = statusLabel === ORDER_PHASE_PREPARING_LABEL && pickupStatus > 0;
      const isContactingAndReverseFlow = statusLabel === ORDER_PHASE_CONTACTING_LABEL && pickupStatus > 0 && orderFlowType === ORDER_FLOW_TYPE.REVERSE;
      return (isDelivering || isPreparingAndPickedUp || isContactingAndReverseFlow);
    })();

    const isDisplayInformations = !isCompleted && order?.delivery?.searchDriver && order?.selfPickupEligible
    const cancellationBy = getCancellationReason(order);
    const shouldHideOrderPhase = order?.delivery?.nature?.toUpperCase() === DELIVEROO && isDelivery(orderType) && pickupStatus > 0 && !shopResponsibleForDelivery
    const shouldDisplayLookingForDriver = order?.deliveryAcceptableByShop || !order?.delivery?.searchDriver || order?.selfPickupEligible;
    return (
      <>
        <Modal
          color='secondary'
          title={`Détails de la commande N°: ${order.orderNumber} ${externalOrderNumber ? `(S-${externalOrderNumber})` : ''}`}
          header
          fixed
          size={isCompleted ? order.orderType === ORDER_TYPE_SEAT && 'md' : 'lg'}
          width={isCompleted ? (!order.orderType === ORDER_TYPE_SEAT ? '700px' : '600px') : '750px'}
          onClick={() => {
            handleClose(this);
          }}
          btnColor='secondary'
          btnTxt='Retour'
          handleClose={() => {
            handleClose(this);
          }}
          isOpen={isOpen}
        >
          <div>
            <div className='row justify-content-center'>
              <div className={`${isDisplayInformations ? 'row col-12' : 'col-9 col-xs-9 col-sm-9 col-md-9 pl-0 justify-content-center'}`}>
                <div className={isDisplayInformations ? isDisplayInformations && ((!checkIntegrationAccess('order', 'hideprintTicket', shopId) && statusLabel !== ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL)) ? `col-md-6 col-sm-12 pl-0` : 'col-md-7 col-sm-12 pl-0' : 'col-12 pl-0'}>
                  {isAllShops &&
                    shop.name &&
                    this.displayOrderDetail({
                      title: 'MAGASIN : ',
                      body: shop.name
                    })}
                  {this.displayOrderDetail({
                    title: 'ÉTAT : ',
                    color:
                      statusLabel === ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL
                        ? mainColor.colorBlue
                        : isCompleted || statusLabel === ORDER_PHASE_CONTACTING_LABEL
                          ? statusLabel !== ORDER_COMPLETED_LABEL
                            ? mainColor.colorRed
                            : mainColor.colorGreen
                          : 'rgb(255, 180, 0)',
                    description: cancellationBy && `(Par ${CANCELLATION_LABELS[cancellationBy] || CANCELLATION_LABELS[DRIVER]})`,
                    body: statusLabel
                  })}
                  {this.displayOrderDetail({
                    title: 'TYPE : ',
                    body: SUITABLE_ORDER_TYPES[orderType]
                  })}
                  {this.displayOrderDetail({
                    title: 'CANAL : ',
                    body: getCanalName(canal)
                  })}
                  {this.displayOrderDetail({
                    title: 'DATE CLIENT:',
                    body:
                      <p
                        className='m-0'
                        style={{
                          width: isDisplayInformations
                            ? `${UNIT * 6.5625}%`
                            : `${UNIT * 8.625}%`,
                        }}
                      >
                        <b>
                          {`${displayDate(date)}${suitableTime(
                            moment(date)
                          )} - ${suitableTime(
                            moment(date).add(
                              hours?.slotInterval ?? DEFAULT_SLOT_INTERVAL, MOMENT_UNIT.MINUTE
                            )
                          )}`}
                        </b>
                      </p>,
                    subtitle: time,
                    isDate: true
                  })}
                  {status === ORDER_PHASE_PREPARING && this.displayOrderDetail({
                    title: 'DATE CUISINE:',
                    body:
                      <p className='m-0' style={{ whiteSpace: 'nowrap' }}>
                        {isDelivery(orderType) ? 'Arrivée du livreur estimée' : 'Sortie de cuisine idéale'} <b>{suitableTime(moment.max(moment(date).subtract(isDelivery(orderType) ? ORDER_PHASE_DELIVERING_TIME : 0, MOMENT_UNIT.MINUTE), moment(datePreparationEnded)))}</b>
                      </p>,
                    subtitle: time,
                    isDate: true
                  })}
                </div>
                {isDisplayInformations &&
                  <>
                    <div
                      className='col-md-5 col-sm-12 d-flex flex-column py-3'
                      style={{
                        height: 'fit-content',
                        borderRadius: UNIT,
                        border: `1px solid`,
                        borderColor: `${setOpacity('255, 180, 0', 0.5)}`,
                        backgroundColor: `${setOpacity('255, 180, 0', 0.25)}`,
                        padding: UNIT * 0.875
                      }}
                    >
                      <div className='mb-0 mb-1'>
                        <h5 className='bold-text' style={{ color: mainColor.colorBlack }}>
                          Information
                        </h5>
                      </div>
                      <div className=''>
                        <p style={{ color: mainColor.colorBlack, fontSize: 12 }}>
                          Nous continuons à chercher un livreur. Afin d'assurer la prise en charge de la commande, nous avons également proposé au client de la récupérer au restaurant.
                        </p>
                      </div>
                    </div>
                  </>
                }
                {isDisplayInformations &&
                  <div className={'col-2 col-xs-2 col-sm-2 col-md-1'}>
                    {this.renderPrintTicketIcon(shopId, status, order, classes)}
                  </div>}
              </div>
              {!isDisplayInformations &&
                <div className={'col-2 col-xs-2 col-sm-2 col-md-2'}>
                  {this.renderPrintTicketIcon(shopId, status, order, classes)}
                </div>}

            </div>
            <div className='row d-flex justify-content-between p-2'>
              {!isCompleted ? (
                <div
                  className='col col-sm-12 col-md-8 col-lg-8 pr-md-3  pr-lg-3 mb-4 mb-md-0 mb-lg-0'
                  style={{ padding: 0, justifyContent: 'stretch' }}
                >
                  {!shouldHideOrderPhase &&
                    < Paper
                      className={getPaperClassName(order, statusLabel, classes, isDisplayDriverDetails, this)}
                    >
                      {(!isLoadingReception || (statusLabel === ORDER_PHASE_DELIVERING_LABEL)) ? (
                        <div>
                          {orderFlowType === ORDER_FLOW_TYPE.REVERSE && statusLabel === ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL ? (
                            shouldDisplayLookingForDriver ?
                              this.displayLookingForDriver(order) : this.displaySearchingDriver(order))
                            :
                            statusLabel === ORDER_PHASE_CONTACTING_LABEL ? (
                              this.displayPhaseOne(order)
                            ) : statusLabel === ORDER_PHASE_PREPARING_LABEL ? (
                              shouldDisplayScheduledMessage(order) && orderFlowType === ORDER_FLOW_TYPE.CLASSIC && this.props.showOrderInPreparation ? this.renderScheduledMessage(order) :
                                (isExternalApp(canal) && canal !== ORDER_DELIVEROO) ||
                                  (canal === ORDER_DELIVEROO && isDelivery(orderType)) ? (
                                  this.displayPhaseThree(order)
                                ) :
                                  this.displayPhaseTwo(order)
                            )
                              : (statusLabel === ORDER_PHASE_TAKEAWAY_LABEL ||
                                statusLabel === ORDER_PHASE_DELIVERING_LABEL ||
                                statusLabel === ORDER_PHASE_WAITER_LABEL) ? (
                                this.displayPhaseThree(order)
                              ) : (
                                <div> {this.displayPhaseFour(order)}</div>
                              )}
                        </div>
                      ) : (

                        <div className={`d-flex h-100 justify-content-center align-items-center ${((statusLabel === ORDER_PHASE_DELIVERING_LABEL && userNameDep) || isLoadingReception) && classes.spinnerStyle}`}>
                          {hasExternalIntegration(shopId) && !isLoadingReception ? (
                            <ScheduledOrderMessage classes={classes} order={order} isFirstPhase={true} />) : (
                            <Spinner />)
                          }

                        </div >
                      )
                      }
                    </Paper >}

                  {
                    shouldDisplaySearchingDriverSection(order, statusLabel, this) && (
                      <Paper className={classes.deliverySectionStyle}>
                        {this.displaySearchingDriver(order)}
                      </Paper>
                    )
                  }

                  {
                    isDisplayDriverDetails &&
                    userNameDep &&
                    this.displayDriverDetail(order, isCompleted, shouldHideOrderPhase)
                  }
                </div >
              ) : null}
              <div
                className={`col-sm-12 col-md-${!isCompleted ? 4 : 12} col-lg-${!isCompleted ? 4 : 12
                  }`}
                style={{ padding: 0, justifyContent: 'stretch' }}
              >
                <Paper className={classes.secondSectionStyle}>
                  <p className={classes.subtitle} style={{ marginBottom: UNIT * 0.3125 }}>
                    COORDONNÉES CLIENT
                  </p>

                  <div className='row'>
                    <div className='col col-sm'>
                      <div>
                        {orderType === ORDER_TYPE_SEAT && (
                          <ListItem
                            title={tableNb || '--'}
                            icon={faUtensils}
                          />
                        )}
                        <ListItem
                          title={`${firstName || '--'} ${lastName.toUpperCase() || ''}`}
                          icon={faUser}
                        />
                        {isExternalApp(canal) && !isObjectNotEmpty(address) ? null : (
                          <ListItem
                            title={isObjectNotEmpty(address) ? getAddressFormatted(address) : '--'}
                            icon={faHome}
                          />
                        )}
                        {isCompleted && this.displayPaymentType(order)}

                        {!isCompleted && (
                          <>
                            {isExternalApp(canal) && !email ? null : (
                              <ListItem title={email || '--'} icon={faEnvelope} />
                            )}
                            {isExternalApp(canal) && !numero ? null : (
                              <ListItem
                                title={numero || '--'}
                                icon={faPhone}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {isCompleted && (
                      <div className='col-sm '>
                        <ListItem title={email || '--'} icon={faEnvelope} />
                        <ListItem title={numero || '--'} icon={faPhone} />
                        {(statusLabel === ORDER_COMPLETED_LABEL ||
                          statusLabel === ORDER_CANCELED_LABEL) &&
                          !isExternalApp(canal) &&
                          this.displayPhaseFour(order)}
                      </div>
                    )}
                  </div>

                </Paper>
                {!isCompleted && (
                  <Paper className={classes.paymentSection}>{this.displayPaymentType(order)}</Paper>
                )}
                {isCompleted &&
                  userNameDep &&
                  this.displayDriverDetail(order, isCompleted, shouldHideOrderPhase)}
              </div>
            </div >

            <div className='row' style={{ padding: '10px' }}>
              <div className='col' style={{ padding: 0 }}>
                <Paper className={classes.paper}>
                  <p className={classes.margeDetail} />
                  <div className={classes.detail}>
                    <p className={classes.subtitle}>RÉCAPITULATIF COMMANDE</p>
                    <br />
                    {_.map(order.commande || order.basket, e => {
                      return (
                        <div key={e.id}>
                          <OrderDetailLine
                            e={e}
                            classes={classes}
                            displayPriceFormat={displayPriceFormat}
                          />

                          <div className={e?.isLoyaltyProduct && classes.orderDetailStyle}>
                            <div style={{ width: e?.isLoyaltyProduct && '82%' }}>
                              {_.keys(e.items).length > 0 ?
                                this.renderOptions(e)
                                : null}
                            </div>

                          </div>
                          {e?.isLoyaltyProduct && e?.price > 0 &&
                            <div style={{
                              display: 'flex',
                              justifyContent: 'flex-end'
                            }}>+ {e.price ? displayPriceFormat(e.price) : displayPriceFormat('')}<b>.Suppl</b></div>}
                          <p className={classes.textDetails}>
                            {e.instruction ? `- Instructions: ${e.instruction}` : null}
                          </p>
                          <hr className={classes.hrStyle} />
                        </div>

                      );
                    })}


                    {renderPromotionBloc({
                      order,
                      orderType,
                      reconversionType,
                      type,
                      promoCode,
                      managementFee,
                      userServicePrice,
                      displayPriceFormat,
                      mainColor,
                      classes
                    })}


                    <hr className={classes.hrStyle} />
                    <p className={classes.totalStyle}>
                      <p className={classes.labelStyle}> TOTAL</p>
                      {displayPriceFormat(totalPriceOrder)}
                    </p>
                  </div>
                </Paper>
              </div>
            </div >
          </div >
        </Modal >

      </>

    );
  }
}
const mapStateToProps = ({ orders, user, firebaseRealTime }) => {
  const { pastOrder, cancelOrder } = orders;
  const { shop = {}, generalConfig = {}, independentDrivers = [], drivers = [] } = firebaseRealTime;
  const { configuration = {} } = shop;
  const {
    webapp = {},
    terminal = {},
    qrcode = {},
    mobileApp = {},
    delivery = {},
    marketplace = {},
    dashboard: generalDashboard, hours = {}
  } = generalConfig;
  const { freelance = false, fleet = {} } = delivery;
  const { showOrderInPreparation = false } = fleet;
  const {
    orderTypes = [ORDER_TYPE_DELIVERY, ORDER_TYPE_COLLECT],
    dashboard, autoAccept
  } = configuration;
  const { shopId, contactingButtons, address = {}, isAllShops, generalAdmin } = user;
  const { location = {} } = address;
  return {
    pastOrder,
    cancelOrder,
    orders: orders.orders,
    shopId,
    orderTypes,
    dashboard,
    contactingButtons,
    shop,
    webapp,
    terminal,
    qrcode,
    mobileApp,
    showOrderInPreparation,
    freelance,
    location,
    independentDrivers,
    drivers,
    marketplace: marketplace.enabled,
    isAllShops,
    generalDashboard,
    generalAdmin, autoAccept, hours
  };
};



export default connect(mapStateToProps, actions)(withStyles(styles)(OrderModal));